import { RootState } from '@dashboard/store'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction, bindActionCreators } from 'redux'

import Component, { StateProps, DispatchProps, OwnProps } from './component'

import {
  getProfileData,
  profileDiscDataKey,
} from '@dashboard/store/actions/profile/discData/data'

const mapStateToProps = (states: RootState, ownProps: OwnProps): StateProps => {
  const { profile } = ownProps
  const { data, dataStates } = states.profile
  const profileContentKey = profileDiscDataKey(profile.id, [
    ['profile', 'overview'],
  ])

  const content = data[profileContentKey] || {}
  const contentState = dataStates[profileContentKey] || 'default'

  return { content, contentState }
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
): DispatchProps => {
  return {
    getProfileData: bindActionCreators(getProfileData, dispatch),
  }
}

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps,
)(Component)
